module.exports = __webpack_public_path__ + "img/jewellery.213e5b1.png";